"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const opaque_1 = require("./framework/opaque");
const Option_1 = require("fp-ts/lib/Option");
const Array_1 = require("fp-ts/lib/Array");
exports.Status = opaque_1.opaqueOfString();
exports.StatusId = opaque_1.opaqueOfNumber();
const StatusesKeys = {
    admin: 'admin',
    habilitated_coach: 'habilitated_coach',
    yobora: 'yobora'
};
exports.Statuses = Object.keys(StatusesKeys).reduce((acc, k) => (Object.assign(Object.assign({}, acc), { [k]: exports.Status.wrap(k) })), {});
exports.atLeastOneOf = (...statuses) => (user_statuses) => statuses.length !== 0 &&
    Option_1.isSome(Array_1.findFirst(us => Option_1.isSome(Array_1.findFirst(s => exports.Status.equals(us, s))(statuses)))(user_statuses));
//# sourceMappingURL=rights.js.map


//////////////////
// WEBPACK FOOTER
// ../models/dist/rights.js
// module id = 62
// module chunks = 12